/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticationTypeDTO,
} from '../models/index';
import {
    AuthenticationTypeDTOFromJSON,
    AuthenticationTypeDTOToJSON,
} from '../models/index';

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI {

    /**
     */
    async getAuthenticationTypeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticationTypeDTO>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Auth/Type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticationTypeDTOFromJSON(jsonValue));
    }

    /**
     */
    async getAuthenticationType(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticationTypeDTO> {
        const response = await this.getAuthenticationTypeRaw(initOverrides);
        return await response.value();
    }

}
